import { useEffect } from 'react';
import Page from 'shared/types/Page'
import getCurrentPage from 'shared/utils/getCurrentPage'


interface useInitProps {
    setSubMenuPages: Function
    curLink: string,
    curLoc: any,
    pages?: Page[],
    label: string
}

const useInit = (props: useInitProps) => {

    useEffect(() => {
        getCurrentPage(props.curLoc).then((curPage) => {
            if (props.pages) {
                
                let subPages: Page[] = []
                props.pages.map((page) => {
                    if (page.dropdownName == props.label)
                        subPages.push(page)
                })
                
                props.setSubMenuPages(subPages)
            }
        })
    }, [])
}

export default useInit